/**
 * @file Prints related queries.
 */

import gql from 'graphql-tag';

export const PhotoPrintSizes = gql`
  query photoPrintSizes {
    photoPrintSizes {
      records {
        id
        name
        price {
          value
          currency
        }
      }
    }
  }
`;
